export default __webpack_public_path__ + "static/media/admin-multi-course-add-bulk-users-example.4465110a.csv";